// extracted by mini-css-extract-plugin
export var actionText = "_kr-4";
export var container = "_kr-0";
export var leftSection = "_kr-1";
export var rightSection = "_kr-2";
export var settingsButton = "_kr-6";
export var settingsIcon = "_kr-7";
export var shortcut = "_kr-5";
export var shortcutGroup = "_kr-3";